import React from "react";

const testimonials = [
  {
    name: "María González",
    role: "Corredora - Propiedades Panamá",
    avatar: "MG",
    content:
      "Las explicaciones después de cada pregunta me ayudaron muchísimo a entender las leyes, no solo a memorizar respuestas. Sentí que realmente estaba aprendiendo y llegué mucho más preparada al examen.",
    rating: 5,
    image: "🏆",
  },
  {
    name: "Carlos Rodríguez",
    role: "Corredor - Propiedades Panamá",
    avatar: "CR",
    content:
      "La plataforma es muy práctica. Los cuestionarios se parecen mucho al examen real y las explicaciones después de cada respuesta hacen que aprendas rápido. La recomiendo totalmente para prepararse.",
    rating: 5,
    image: "📚",
  },
  {
    name: "Ana Castillo",
    role: "Corredora - Propiedades Panamá",
    avatar: "AC",
    content:
      "Probé varios métodos para estudiar, pero esta plataforma fue la que más me ayudó. Poder practicar pregunta por pregunta hace toda la diferencia.",
    rating: 5,
    image: "🌟",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-bold text-blue-600 uppercase tracking-wider">
            Testimonios
          </span>
          <h2 className="text-4xl md:text-5xl font-black mt-4 mb-6 bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
            Lo que dicen nuestros estudiantes
          </h2>
          <p className="text-xl text-slate-600">
            Ellos ya confían en PanamaBR para su Preparación.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-3xl border border-slate-200 shadow-lg hover:shadow-xl transition-shadow"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Content */}
              <p className="text-slate-700 mb-8 leading-relaxed">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center text-white font-bold">
                  {testimonial.avatar}
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-slate-500">{testimonial.role}</p>
                </div>
                <span className="ml-auto text-4xl">{testimonial.image}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
